import date, { dateFormats } from './date'
import lowerCase from './lowerCase'
import properCase from './properCase'
import upperCase from './upperCase'
import numbersOnly from './numbersOnly'
import phone from './phone'

export default {
	date,
	dateFormats,
	lowerCase,
	properCase,
	upperCase,
	numbersOnly,
	phone
}
